/**
 * 统一请求头配置
 * 管理所有固定的请求头参数
 */

import { getDeviceIdSync } from '@/utils/fingerprint'

/**
 * 获取设备 ID
 * 使用浏览器指纹作为设备唯一标识
 */
function getDeviceId() {
  return getDeviceIdSync()
}

/**
 * 获取语言代码
 * 从浏览器语言或用户配置中获取
 */
function getLanguage() {
  // 优先从 localStorage 读取用户选择的语言
  const savedLanguage = localStorage.getItem('user_language')
  if (savedLanguage) {
    return savedLanguage
  }

  // 从浏览器语言获取（返回完整格式，如 'en-US'）
  return navigator.language || navigator.userLanguage || 'en-US'
}

/**
 * 固定请求头配置
 * 注意：请求头名称需严格匹配后端服务器允许的 Access-Control-Allow-Headers
 */
export const FIXED_HEADERS = {
  // API 密钥（注意：后端要求首字母大写 K）
  ApiKey: import.meta.env.VITE_API_KEY,

  // TODO:设备唯一标识（后端使用 DeviceToken 而非 Deviceid）
  get DeviceToken() {
    return getDeviceId()
  },

  // 代码版本标签（格式：包名-版本号）
  get Codetag() {
    const packageName = import.meta.env.VITE_PACKAGE_NAME
    // const version = __APP_VERSION__ || '1.0.0'
    // 使用 9.9.9 版本号，服务端部分接口（如登录返回 IM 相关信息）对版本号有要求
    return `${packageName}-9.9.9`
  },

  // 渠道标识
  Channel: import.meta.env.VITE_CHANNEL,

  // TODO:语言代码（后端使用 language 而非 nation）
  get language() {
    return getLanguage()
  },
}

/**
 * 获取所有固定请求头（转换 getter 为实际值）
 * @returns {Object} 请求头对象
 */
export function getFixedHeaders() {
  return {
    ApiKey: FIXED_HEADERS.ApiKey,
    DeviceToken: FIXED_HEADERS.DeviceToken,
    Codetag: FIXED_HEADERS.Codetag,
    Channel: FIXED_HEADERS.Channel,
    language: FIXED_HEADERS.language,
  }
}

/**
 * 更新语言设置（用户手动选择时调用）
 * @param {string} languageCode - 语言代码，如 'en-US', 'zh-CN' 等
 */
export function updateLanguage(languageCode) {
  if (languageCode) {
    localStorage.setItem('user_language', languageCode)
  }
}

/**
 * 重置设备 ID（测试用，慎用）
 */
export function resetDeviceId() {
  localStorage.removeItem('device_id')
}
